import React from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";

const MenuBar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  const btnStyle = (isActive) => ({
    padding: "0.25rem 0.5rem",
    borderRadius: "0.25rem",
    border: "none",
    background: isActive ? "#e0ffe1" : "transparent",
    color: isActive ? "#237e22" : "var(--color-text-muted, #64748b)",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "0.85rem",
    transition: "all 0.2s"
  });

  return (
    <div style={{
      display: "flex",
      gap: "0.5rem",
      padding: "0.5rem",
      borderBottom: "1px solid var(--color-border, #cbd5e1)",
      flexWrap: "wrap",
      backgroundColor: "#f8fafc",
      borderTopLeftRadius: "0.5rem",
      borderTopRightRadius: "0.5rem"
    }}>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBold().run()}
        style={btnStyle(editor.isActive("bold"))}
      >
        Negrito
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleItalic().run()}
        style={btnStyle(editor.isActive("italic"))}
      >
        Italico
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        style={btnStyle(editor.isActive("heading", { level: 2 }))}
      >
        Título 2
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
        style={btnStyle(editor.isActive("heading", { level: 3 }))}
      >
         Título 3
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        style={btnStyle(editor.isActive("bulletList"))}
      >
        Lista
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        style={btnStyle(editor.isActive("orderedList"))}
      >
        Lista enumerada
      </button>
    </div>
  );
};

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({
        placeholder: placeholder || "Escreva aqui...",
      }),
    ],
    content: value,
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    editorProps: {
      attributes: {
        class: "tiptap-editor-content",
        style: "padding: 1rem; min-height: 150px; outline: none;",
      },
    },
  });

  return (
    <div style={{
      border: isFocused ? "1px solid rgba(245, 91, 36, 0.7)" : "1px solid var(--color-border, #cbd5e1)",
      boxShadow: isFocused ? "0 0 0 3px rgba(245, 91, 36, 0.14)" : "none",
      borderRadius: "0.5rem",
      backgroundColor: "white",
      overflow: "hidden",
      transition: "all 0.2s ease"
    }}>
      <MenuBar editor={editor} />
      <EditorContent editor={editor} />
      <style>{`
        .tiptap-editor-content p.is-editor-empty:first-child::before {
          content: attr(data-placeholder);
          float: left;
          color: #adb5bd;
          pointer-events: none;
          height: 0;
        }
        .tiptap-editor-content p { margin-bottom: 0.5rem; }
        .tiptap-editor-content h2 { margin-top: 1rem; margin-bottom: 0.5rem; font-size: 1.25rem; font-weight: 600; }
        .tiptap-editor-content h3 { margin-top: 1rem; margin-bottom: 0.5rem; font-size: 1.1rem; font-weight: 600; }
        .tiptap-editor-content ul { list-style-type: disc; padding-left: 1.5rem; }
        .tiptap-editor-content ol { list-style-type: decimal; padding-left: 1.5rem; }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
